<h2 mat-dialog-title class="text-center">
  <div [ngSwitch]="data.type">
    <div *ngSwitchCase="'Add'">{{ "addCategory" | translate }}</div>
    <div *ngSwitchCase="'Edit'">{{ "editCategory" | translate }}</div>
  </div>
</h2>
<mat-dialog-content>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <mat-form-field appearance="outline" floatLabel="always" class="form-group w-100">
      <mat-label>{{ "form.product.category" | translate }}</mat-label>
      <input matInput class="form-control" required formControlName="prdCatNameEn" autocomplete="off" (keyup)="onValidateCategoryName($event)">
      <mat-error *ngIf="form.controls['prdCatNameEn'].hasError('separator')">{{ "categories.nameNoSeparator" | translate }}</mat-error>
    </mat-form-field>
    <!-- Empty means a top-level category. -->
    <mat-form-field appearance="outline" floatLabel="always" class="form-group w-100">
      <mat-label>{{ "categories.parent" | translate }}</mat-label>
      <mat-select formControlName="prdCatParentID">
        <mat-option [value]="null">{{ "categories.noParent" | translate }}</mat-option>
        <mat-option *ngFor="let row of parentOptions" [value]="row.category.prdCatID">{{ row.path }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-dialog-actions align="center">
      <button mat-button mat-dialog-close>{{ "cancel" | translate }}</button>
      <button mat-button color="primary" [mat-dialog-close]="true" [disabled]="!form.valid" type="submit">
        <span *ngIf="data.type == 'Add'; else editBlock"> {{ "add" | translate }}</span>
        <ng-template #editBlock>{{ "save" | translate }}</ng-template>
      </button>
    </mat-dialog-actions>
  </form>
</mat-dialog-content>
